
namespace Matrix.Data {

    @Serenity.Decorators.registerEditor("Matrix.Data.SecurityMergeInspectionTable")
    @Serenity.Decorators.element("<div/>")
    export class SecurityMergeInspectionTable extends Serenity.DataGrid<any, any> {

        private autoSize: Serenity.AutoColumnWidthMixin;

        constructor(container) {
            super(container);

            this.autoSize = new Serenity.AutoColumnWidthMixin({
                grid: this, maxRows:200
            });

            new Serenity.HeaderFiltersMixin({
                grid: this,
                filterByText: true
            });
        }

        protected getIdProperty() {
            return "field";
        }

        public getColumns() {
            return this.getDefaultCols();
        }

        protected getGridCanLoad() {
            return false;
        }

        protected usePager() {
            return false;
        }

        protected getButtons() {
            return null;
        }

        private _hideBlankRows: boolean = true;

        get hideBlankRows() {
            return !!this._hideBlankRows;
        }

        set hideBlankRows(value) {
            this._hideBlankRows = !!value;
            this.view.refresh();
            this.updateStyles();
            this.slickGrid.invalidate();
        }

        protected onViewFilter(item) {
            return super.onViewFilter(item) && (!this._hideBlankRows || !item.$blank);
        }

        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.frozenColumn = 1;
            return opt;
        }

        protected getDefaultCols() {
            return [
                {
                    name: '',
                    field: '$attr',
                    id: '$attr',
                    sortable: true
                },
                {
                    name: 'Master',
                    field: '$master',
                    id: '$master',
                    sortable: true
                }
            ];
        }

        getViewOptions() {
            var opt = super.getViewOptions();

            opt.localSort = true;

            return opt;
        }

        private security: SecurityRow;
        private merge: SecurityMergeRow[];
        private priorityBySource: Q.Grouping<SecurityMergePriorityRow>;
        private sortedSources: SecurityMergePriorityRow[];
        private sortedSourceCodes: string[];

        setMergeData(security: SecurityRow, merge: SecurityMergeRow[]) {
            SecurityMergePriorityService.List({
            },
                response => {
                    this.security = security;
                    this.merge = merge;
                    this.priorityBySource = Q.toGrouping(response.Entities, x => x.SourceCode);
                    this.sortedSources = response.Entities.slice().sort((x, y) => (x.Priority || 10000) < (y.Priority || 10000) ? 1 : ((x.Priority || 10000) > (y.Priority || 10000) ? -1 : 0));
                    this.sortedSourceCodes = [];
                    for (var sc of this.sortedSources.map(x => x.SourceCode))
                        if (this.sortedSourceCodes.indexOf(sc) < 0)
                            this.sortedSourceCodes.push(sc);
                    var mergeColByField: Q.Dictionary<Slick.Column> = {};
                    var items: any[] = [];
                    for (var propItem of Q.getColumns("Data.SecurityMerge").filter(x => x.name &&
                        !securityMergeNoHint[x.name] &&
                        x.sortable !== false && x.notFilterable !== true)) {
                        var item = {
                            field: propItem.name,
                            $attr: Q.text(propItem.title) || propItem.name,
                            $master: this.security[propItem.name],
                            $blank: true
                        }
                        items.push(item);
                        mergeColByField[item.field] = Serenity.PropertyItemSlickConverter.toSlickColumn(propItem);
                    }

                    var itemByField: Q.Dictionary<any> = {};
                    items.forEach((x, i) => {
                        itemByField[x.field] = x;
                    });

                    var cols: Slick.Column[] = this.getDefaultCols();

                    for (var sourceCode of this.sortedSourceCodes) {
                        var ml = this.merge.filter(x => x.SourceCode.toLowerCase() == sourceCode.toLowerCase());
                        for (var m of ml) {
                            var key = sourceCode + '$' + m.SourceSecurityId;
                            var name = titleize(sourceCode);
                            if (ml.length > 1) {
                                name += ' (' + m.SourceSecurityId + ')';
                            }
                            cols.push({
                                name: name,
                                field: key,
                                id: key,
                                sortable: true
                            });

                            for (var field of Object.keys(itemByField)) {
                                itemByField[field][key] = m[field];
                            }
                        }
                    }

                    items = items.sort((x, y) => {
                        var xHasVal = Q.any(this.sortedSourceCodes, s => x[s] != null);
                        var yHasVal = Q.any(this.sortedSourceCodes, s => y[s] != null);
                        if (xHasVal && !yHasVal)
                            return -1;
                        if (yHasVal && !xHasVal)
                            return 1;
                        return 0;
                    });

                    cols.forEach(c => {
                        if (c.field !== "$attr") {
                            c.formatter = Serenity.SlickHelper.convertToFormatter(ctx => {
                                var key = ctx.item.field as string;
                                var field = key;
                                var idx = field.indexOf('$');
                                if (idx > 0)
                                    field = field.substr(0, idx);
                                var mergecol = mergeColByField[field];
                                if (!field || !mergecol || !mergecol.format)
                                    return Q.htmlEncode(ctx.value);
                                try {
                                    return mergecol.format({
                                        item: {
                                            [key]: ctx.value
                                        },
                                        value: ctx.value,
                                        row: -1,
                                        cell: -1,
                                        column: mergecol
                                    });
                                }
                                catch {
                                    return Q.htmlEncode(ctx.value);
                                }
                            });

                            // for sorting to work properly on displayed values
                            for (var item of items) {
                                item.$blank = item.$blank && (item[c.field] == null || item[c.field] == '');
                                item[c.field + "__org"] = item[c.field];
                                item[c.field] = c.formatter(0, 0, item[c.field], c, item);
                            }

                            c.formatter = (row, cell, value) => value?.toString();
                            c.format = null;
                        }
                    });

                    this.view.setItems(items, true);
                    this.slickGrid.setColumns(cols);

                    this.updateStyles();
                    this.autoSize.autoSizeAllColumns();
                    this.slickGrid.render();
                }
            );
        }

        updateStyles() {
            var styles: any = {};
            for (var row = 0; row < this.slickGrid.getDataLength(); row++) {
                var hl: any = {};
                var it = this.slickGrid.getDataItem(row);
                var field = it.field as string;
                if (this.security[field] != null)
                    hl["$master"] = "highlight-match";
                for (var sourceCode of this.sortedSourceCodes) {
                    var ml = this.merge.filter(x => x.SourceCode == sourceCode);
                    for (var m of ml) {
                        var key = sourceCode + '$' + m.SourceSecurityId;

                        if (m[field] != null) {
                            var pri = this.priorityBySource[sourceCode] || [];
                            if (pri && !Q.any(pri, p => p[field]))
                                hl[key] = "highlight-unused";
                            else if (this.security[field] == m[field])
                                hl[key] = "highlight-match";
                            else
                                hl[key] = "highlight-mismatch";
                        }
                    }
                }

                if (Object.keys(hl).length > 0)
                    styles[row] = hl;
            }
            this.slickGrid.setCellCssStyles("mergematch", styles);
        }
    }
}